import Tooltip from "tooltip.js"

/**
 * Tooltip Component
 *
 * @constructor
 */

export default function()
{
    const configSpecific = {
        'service-backconnect-proxies': {
            html: true,
            title:
                `<div class="title">Backconnect<br>Proxies</div>
                <div class="item"><span>Targeting: Country, City, ISP & ASN</span></div>
                <div class="item"><span>Developer Friendly API</span></div>
                <div class="item"><span>Pool of 31 Million IPs</span></div>
                <div class="item"><span>Real Residential IPs</span></div>
                <div class="item"><span>Instant Scaling</span></div>`,
            placement: 'bottom',
            class: 'service',
            link: '/services/backconnect-proxies',
            popperOptions: {
                modifiers: {
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        escapeWithReference: true
                    }
                }
            }
        },
        'service-dedicated-proxies': {
            html:true,
            title:
                `<div class="title">Dedicated HTTP/S<br>Proxies</div>
                <div class="item"><span>99,99 Guaranteed Uptime</span></div>
                <div class="item"><span>Super Speed 1GBPS</span></div>
                <div class="item"><span>Unlimited Bandwidth</span></div>
                <div class="item"><span>Non Sequential IPs</span></div>
                <div class="item"><span>Multiple Subnets</span></div>`,
            placement: 'bottom',
            class: 'service',
            link: '/services/dedicated-proxies',
            popperOptions: {
                modifiers: {
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        escapeWithReference: true
                    }
                }
            }
        },
        'service-shared-proxies': {
            html:true,
            title:
                `<div class="title">Shared HTTP/S<br>Proxies</div>
                <div class="item"><span>99,99 Guaranteed Uptime</span></div>
                <div class="item"><span>Super Speed 1GBPS</span></div>
                <div class="item"><span>Unlimited Bandwidth</span></div>
                <div class="item"><span>Non Sequential IPs</span></div>
                <div class="item"><span>Multiple Subnets</span></div>`,
            placement: 'bottom',
            class: 'service',
            link: '/services/shared-proxies',
            popperOptions: {
                modifiers: {
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        escapeWithReference: true
                    }
                }
            }
        },
        'buy-proxies': {
            html:true,
            title:
                `<div class="title">Pool of 31<br>Million IPs</div>
                <div class="item"><span>Targeting: Country, City, ISP & ASN</span></div>
                <div class="item"><span>Developer Friendly API</span></div>
                <div class="item"><span>Pool of 31 Million IPs</span></div>
                <div class="item"><span>Real Residential IPs</span></div>
                <div class="item"><span>Instant Scaling</span></div>`,
            placement: 'bottom',
            class: 'service',
            link: '#plans',
            popperOptions: {
                modifiers: {
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        escapeWithReference: true
                    }
                }
            }
        },
    }

    for(const el of document.querySelectorAll('[data-tooltip-config]')) {
        const configName = el.getAttribute('data-tooltip-config')
        const extraClass = el.getAttribute('data-tooltip-theme') || (configSpecific[configName] && configSpecific[configName]['class'])
        const template =
            `<a href="${configSpecific[configName].link || '#'}" class="tooltip ${extraClass}" role="tooltip">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner"></div>
            </a>`

        const options = Object.assign({}, {
            title: el.getAttribute('data-tooltip-text'),
            trigger: 'hover',
            placement: el.getAttribute('data-tooltip-position') || 'top',
            html: el.getAttribute('data-tooltip-html') || false,
            container: 'body',
            delay: {
                show: el.getAttribute('data-tooltip-show-delay') || 0,
                hide: 0
            },
            template
        }, configSpecific[configName])

        new Tooltip(el, options)
    }
}
